export default "/assets/images/quiet-mode.mp4?e967e1e1c54ba8c7c86df9633b4f99c8";